// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3hxSn","buttons":"Footer_buttons__1wRjf"};